import type { NavigateFunction } from "react-router-dom";

export type RouterLocation = {
  pathname: string;
  search?: string;
  hash?: string;
  state?: unknown;
};

let navigateRef: NavigateFunction | null = null;

export function setAppNavigate(navigate: NavigateFunction): void {
  navigateRef = navigate;
}

function toPath(location: RouterLocation): string {
  return `${location.pathname}${location.search ?? ""}${location.hash ?? ""}`;
}

/** Redux-thunk compatible replacement for connected-react-router `push`. */
export function push(path: string) {
  return () => {
    navigateRef?.(path);
  };
}

/** Redux-thunk compatible replacement for connected-react-router `replace`. */
export function replace(location: RouterLocation) {
  return () => {
    navigateRef?.(toPath(location), {
      replace: true,
      state: location.state
    });
  };
}

/** Redux-thunk compatible replacement for connected-react-router `goBack`. */
export function goBack() {
  return () => {
    navigateRef?.(-1);
  };
}
